/* globals window */

import logLevels from './logLevels';

/**
 * Logger
 */
const logger = ((window, console, localStorage) => {
  const hasConsole = !!console;
  const hasLocalStorage = !!localStorage;
  const logLevel = getLogLevel();
  const showLogs = logLevel === logLevels.ALL;

  /**
   * Outputs the message to the console
   * @param {String} message
   * @param {String} [method=log]
   */
  function output(message, method = 'info') {
    if (hasConsole) {
      const useMethod = console[method] ? method : 'log';
      console[useMethod](message);
    }
  }

  /**
   * Returns the available log level
   * @return {String}
   */
  function getLogLevel() {
    let level = logLevels.NONE;

    if (hasLocalStorage && localStorage.getItem('logLevel')) {
      level = localStorage.getItem('logLevel');
    }

    return level;
  }

  const api = {
    /**
     * Displays a 'created' log in the console
     * @param {Function} component
     * @param {String} selector
     */
    created: (component, selector) => {
      if (showLogs) {
        output(`[CREATED]: ${component.name} for ${selector}`);
      }
    },

    /**
     * Displays a 'notice' log in the console
     * @param {String} message
     */
    notice: (message) => {
      if (showLogs || logLevel === logLevels.NOTICE) {
        output(`[NOTICE]: ${message}`);
      }
    },

    /**
     * Displays a 'warning' log in the console
     * @param {String} message
     */
    warning: (message) => {
      if (showLogs || logLevel === logLevels.WARNING) {
        output(`[WARNING]: ${message}`, 'warn');
      }
    },

    /**
     * Displays a 'warning' log in the console
     * @param {String} message
     */
    failed: (message) => {
      if (showLogs || logLevel === logLevels.WARNING) {
        output(`[FAILED]: ${message}`, 'warn');
      }
    },

    /**
     * Displays an 'error' log in the console
     * @param {String} message
     */
    error: (message) => {
      if (showLogs || logLevel === logLevels.ERROR) {
        output(`[ERROR]: ${message}`, 'error');
      }
    },
  };

  return api;
})(window, window.console, window.localStorage);

export default logger;



// WEBPACK FOOTER //
// ./resources/assets/js/components/logger/logger.js